module.exports = __webpack_public_path__ + "media/ecom/StorageBadge-90d61ab4.svg";